<template>
  <div>
    <div class="background-container">
      <img
        class="main-logo"
        :src="require('../assets/img/main_logo.png')"
        alt="메인로고"
      />
      <div class="background-container-inner">
        <div ref="swiper" class="swiper">
          <div class="swiper-wrapper" style="pointer-events: none">
            <!-- Slides -->
            <div class="swiper-slide first-main"></div>
            <div class="swiper-slide first-main second-main"></div>
            <div class="swiper-slide first-main third-main"></div>
          </div>

          <div class="swiper-pagination"></div>
        </div>
      </div>

      <div class="main-content-inner">
        <div class="main-banner-content">
          <div class="main-banner-sub">
            <img
              class="main-sub-icon"
              :src="require('../assets/img/congress_monitoring.png')"
              alt="메뉴"
            />
            <div>
              <div class="title" v-html="textContent"></div>
              <div class="sub">
                국회의원의 법안 발의 및 처리와 관련된 각종 데이터를 제공합니다.
              </div>
            </div>
          </div>
          <div class="main-banner-sub">
            <img
              class="main-sub-icon"
              :src="require('../assets/img/legislative_commentary.png')"
              alt="메뉴"
            />
            <div>
              <div class="title">입법평론</div>
              <div class="sub">
                입법평론은 국회의원의 입법 활동에 대한 분석과 해설입니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SubMain />
  </div>
</template>

<script>
import SubMain from "@/components/main/SubMain.vue";
//
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
  name: "MainPage",

  components: { SubMain },

  data() {
    return {
      activeIndex: 0,
      textContent: "국회 입법 모니터링 현황판",
    };
  },

  mounted() {
    new Swiper(this.$refs.swiper, {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      direction: "vertical",
      autoHeight: true,
      mousewheel: false,
      touchStartPreventDefault: true,
      autoplay: {
        delay: 10000,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });

    window.addEventListener("resize", this.checkScreenWidth);

    if (window.innerWidth <= 1040) {
      this.textContent = "국회 입법<br/>모니터링 현황판"; // 600px 이하일 때 텍스트 변경
    } else {
      this.textContent = "국회 입법 모니터링 현황판"; // 기본 텍스트
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);
  },

  methods: {
    checkScreenWidth() {
      if (window.innerWidth <= 1040) {
        this.textContent = "국회 입법<br/>모니터링 현황판"; // 600px 이하일 때 텍스트 변경
      } else {
        this.textContent = "국회 입법 모니터링 현황판"; // 기본 텍스트
      }
    },
  },
};
</script>

<style scoped>
.background-container {
  height: 800px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-attachment: fixed;

  @media only screen and (max-width: 1040px) {
    height: 800px;
    overflow-x: hidden;
    background-attachment: initial;
  }
}

.background-container-inner {
  height: 800px;
  width: 100%;
  position: relative;
  border-radius: 0 0 0 200px;
  overflow: hidden;

  @media only screen and (max-width: 1040px) {
    border-radius: 0;
    height: 800px;
  }
}

.first-main {
  height: 800px !important;
  width: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/img/main_01.jpg");
  background-size: cover;
  background-position: center;

  @media only screen and (max-width: 1040px) {
    height: 800px !important;
  }
}

.second-main {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/img/main_02.jpg");
}

.third-main {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/img/main_03.jpg");
}

.swiper-pagination {
  margin-right: 85px;

  @media only screen and (max-width: 1040px) {
    margin-right: 0;
    display: flex;
    gap: 74px;
    align-items: center;
    position: absolute;
    height: 40px;
    bottom: 0;
    right: auto;
    top: 500px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.background-container-inner >>> .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background-color: #fff;
  margin: 25px 0;
  opacity: 1;

  @media only screen and (max-width: 1040px) {
    width: 20px;
    height: 20px;
  }
}

.background-container-inner >>> .swiper-pagination-bullet-active {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border: solid 1px #005aab;
  text-align: center;
  background-color: rgba(0, 90, 171, 0.5);
  margin-left: -15px;

  @media only screen and (max-width: 1040px) {
    margin-left: -7px;
    margin-right: -7px;
  }
}

.background-container-inner >>> .swiper-pagination-bullet-active::before {
  content: "";
  width: 10px;
  height: 10px;
  background-color: #fff;
  display: inline-block;
  border-radius: 50%;
}

.main-content-inner {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 200px;
  z-index: 2;
}

.main-logo {
  height: 360px;
  position: absolute;
  z-index: 3;
  margin-top: -70px;

  @media only screen and (max-width: 1040px) {
    top: 225px;
    height: auto;
  }
}

.main-banner-content {
  height: 200px;
  border-top: 1px #fff solid;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 48px;
  justify-content: center;
  padding: 0 60px;

  @media only screen and (max-width: 1040px) {
    height: 200px;
    padding: 0 6vw;
  }
}

.main-banner-sub {
  display: flex;
  color: #fff;
  gap: 30px;
  align-items: center;

  @media only screen and (max-width: 1040px) {
    flex-direction: column;
    gap: 28px;
  }
}

.main-sub-icon {
  width: 98px;

  @media only screen and (max-width: 1300px) {
    width: 70px;
  }
}

.main-banner-content .title {
  font-size: 30px;
  margin-bottom: 14px;
  font-weight: 500;

  @media only screen and (max-width: 1040px) {
    text-align: center;
    font-size: 4vw;
  }
}

.main-banner-content .sub {
  font-size: 20px;
  font-weight: 500;

  @media only screen and (max-width: 1040px) {
    display: none;
  }
}
</style>
